import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import './SuperAdminLogin.css';

const SuperAdminLogin = () => {
  const [userName, setuserName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // Add ref to track component mounted state
  const [abortController] = useState(new AbortController());

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, [abortController]);

  const history = useHistory();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${config.serverUrl}/superadmin/login`,
        {
          username: userName,
          password
        },
        {
          signal: abortController.signal
        }
      );

      localStorage.setItem('superAdminToken', response.data.token);
      history.push('/dashboard');
    } catch (error) {
      if (error.name === 'AbortError') {
        return; // Request was aborted, do nothing
      }
      if (error.code === 'ERR_NETWORK') {
        setError('Cannot connect to server. Please check if the server is running.');
      } else {
        setError(error.response?.data?.message || 'Login failed. Please try again.');
      }
      console.error('Login failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleLogin} className="login-form">
        <div className="logo-container">
          <div className="logo">
            {/* Add your logo image here */}
            <span style={{ fontSize: '24px', color: '#4a90e2' }}>SA</span>
          </div>
          <h2>Super Admin Login</h2>
        </div>
        {error && <div className="error-message">{error}</div>}
        <div className="form-group">
          <input
            type="text"
            placeholder="Username"
            value={userName}
            onChange={(e) => setuserName(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="login-button" type="submit" disabled={isLoading}>
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default SuperAdminLogin;
